import { Form, FormItem } from './Form';
Form.FormItem = FormItem;
export { Form };